
/**
  * @ngdoc component
  * @name common.product.component:itxProductStockAvailability
  *  
  * @param {Object} data Description 
  * @param {Function} closeDialog close dialog function
  *
  * @description
  * description
  * 
*/
(function () {

    'use strict';

    var ItxProductStockAvailabilityCmp = {
        bindings: {
            data: '<',
            onCloseDialog: '&'
        },
        controller: ItxProductStockAvailabilityCmpCtrl,
        controllerAs: '$ctrl',
        templateUrl: 'product-stock-availability.component.html'
    };

    ItxProductStockAvailabilityCmpCtrl.$inject = [
        '$scope',
        'ItxErrorMessagesFct', 
        'ItxLoginSvc',
        'ItxScreenSizeSvc',
        'CsBsService',
        'imStockAvailabilityService',
        'imDispatcherService'
    ];

    function ItxProductStockAvailabilityCmpCtrl(
        $scope,
        ItxErrorMessagesFct, 
        ItxLoginSvc,
        ItxScreenSizeSvc,
        CsBsService,
        imStockAvailabilityService,
        imDispatcherService
    ) {

        var _this = this;

        _this.$onInit = function() {
            _this.bsCsEnable = false;
            _this.desktop = ItxScreenSizeSvc.is('md,lg');
            _this.ItxErrorMessagesFct = ItxErrorMessagesFct;
            _this.product = _this.data.product;
            _this.selectedSize = _this.data.selectedSize;
            _this.activeSection = 'stock-availability';
            _this.model = {};
            _this.model.email = inditex.iUserJSON.email;

            inditex.getXconfiguracionValue('PHONE_REGISTER_LOGIN_ENABLED', function (status, value) {
                const regexp = joyr.validation.regex.email();
                if (value == 1 && !regexp.test(inditex.iUserJSON.email)) {
                    _this.model.email = "";
                }
            });

            _this.isSubscribedCsBs = inditex.iUserJSON.isSubscribedComingBackSoon;
            _this.isSubscribedComingBackSoon = false;
            _this.bsCs();
            _this.isLogged();
            if(_this.isSubscribedCsBs && _this.isUserLogged){
                _this.isSubscribedComingBackSoon = true;
            }
            imStockAvailabilityService.createPopupView(_this.product, _this.selectedSize);
        };

        _this.onRelatedCarrouselVisible = function() {
            _this.relatedsCarrouselVisible = true;
        };

        _this.isLogged =  function(){
            _this.isUserLogged = ItxLoginSvc.isLogged();
        };

        _this.isActive = function (what) {
            var sections = what.split(',');
            return sections.indexOf(_this.activeSection) !== -1;
        };

        _this.bsCs = function () {
            CsBsService.isEnabled()
            .then(function(enabled){
                _this.bsCsEnable = enabled;
            });
        };

        _this.notifyStock = function () {
            _this.stockAvailabilityForm.$setSubmitted();
            if (_this.stockAvailabilityForm.$valid) {
                joyr.rest.xRestRequestStockNotification(inditex.iCategoryId || 0, _this.product.id,
                    _this.selectedSize.sku, 1, {email: _this.model.email})
                    .done(function () {
                        _this.activeSection = 'stock-availability-success';
                        imStockAvailabilityService.createNotificationEvent(_this.product, _this.selectedSize);
                    })
                    .Catch(function (error) {
                        ItxErrorMessagesFct.add(error, 'productStockAvailabilityCtrl', 'ERROR');
                        imStockAvailabilityService.createServerErrorEvent(_this.selectedSize, _this.stockAvailabilityForm, error);
                    })
                    .Finally(function () {
                        $scope.$apply();
                    });
            } else {
                imStockAvailabilityService.createFormErrorEvent(_this.selectedSize, _this.stockAvailabilityForm);
            }
        };
        _this.close = function(){
            _this.onCloseDialog();
        };
        _this.$onDestroy = function () {
            _this.ItxErrorMessagesFct.reset('productStockAvailabilityCtrl', 'ERROR');
            imDispatcherService.sortEvent('pageview', _this.product);
        };
    }
    
    angular.module('itxApp.common')
        .component('itxProductStockAvailability', ItxProductStockAvailabilityCmp);

})();
